import { useEffect } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { imageUrl } from "@/lib/api";

export const isPdf = (p) => /\.pdf($|\?)/i.test(p || "");

// Full-screen preview of one or many images (or a PDF), with prev/next navigation.
export function MediaPreview({ items, index, onIndex, onClose, title, lang, testid = "media-preview" }) {
  const L = (ar, en) => (lang === "ar" ? ar : en);
  const open = index !== null && index >= 0 && index < items.length;
  const many = items.length > 1;
  const go = (d) => onIndex((index + d + items.length) % items.length);
  useEffect(() => {
    if (!open || !many) return;
    const k = (e) => { if (e.key === "ArrowLeft") go(lang === "ar" ? 1 : -1); if (e.key === "ArrowRight") go(lang === "ar" ? -1 : 1); };
    window.addEventListener("keydown", k);
    return () => window.removeEventListener("keydown", k);
  });
  const src = open ? imageUrl(items[index]) : "";
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-4xl w-[95vw] p-0 bg-black border-0 overflow-hidden [&>button]:hidden" data-testid={testid}>
        <DialogTitle className="sr-only">{title}</DialogTitle>
        <div className="flex items-center justify-between px-4 py-3 bg-[#064E3B] text-white" dir={lang === "ar" ? "rtl" : "ltr"}>
          <span className="font-bold text-sm">{title}{many && ` (${index + 1}/${items.length})`}</span>
          <button type="button" onClick={onClose} className="p-1 rounded-full hover:bg-white/15" data-testid={`${testid}-close`}><X className="w-5 h-5" /></button>
        </div>
        <div className="relative flex items-center justify-center h-[75vh]">
          {open && (isPdf(items[index])
            ? <iframe src={src} title={title} className="w-full h-full bg-white" data-testid={`${testid}-pdf`} />
            : <img key={src} src={src} alt="" className="animate-in fade-in duration-300 max-w-full max-h-full object-contain" data-testid={`${testid}-image`} />)}
          {many && <>
            <button type="button" onClick={() => go(-1)} aria-label={L("السابق", "Previous")} className="absolute start-3 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/35 text-white rounded-full p-2" data-testid={`${testid}-prev`}><ChevronRight className="w-6 h-6 ltr:rotate-180" /></button>
            <button type="button" onClick={() => go(1)} aria-label={L("التالي", "Next")} className="absolute end-3 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/35 text-white rounded-full p-2" data-testid={`${testid}-next`}><ChevronLeft className="w-6 h-6 ltr:rotate-180" /></button>
          </>}
        </div>
        {many && (
          <div className="flex gap-2 p-3 overflow-x-auto bg-black" data-testid={`${testid}-thumbs`}>
            {items.map((p, i) => (
              <button type="button" key={p} onClick={() => onIndex(i)} className={`shrink-0 w-14 h-14 rounded-lg overflow-hidden border-2 ${i === index ? "border-[#D4AF37]" : "border-transparent opacity-60"}`} data-testid={`${testid}-thumb-${i}`}>
                <img src={imageUrl(p)} alt="" className="w-full h-full object-cover" />
              </button>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
